import React from "react";
import SalaryComponent from "../../components/Salary/Salary.component";
import IPage from "../../interfaces/page"

const SalaryPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <SalaryComponent></SalaryComponent>;
};

export default SalaryPage;
